import { DragAndDropPinComponent } from '@lessonup/pin-renderer';
import {
  AnimatedComponent,
  checkIsOverCorrectDropzone,
  useCurrentPin,
  useCurrentViewByType,
  useDragAndDropAnimation,
} from '@lessonup/players-modern';
import { cssBase } from '@lessonup/ui-components';
import React, { useEffect, useMemo } from 'react';
import { DragAndDropRealtimePlayerProps } from './DragAndDropRealtimePlayer.types';

const transitionStyle = cssBase`
  & [data-comp-id] {
    transition: all 0.8s ease-in-out;
  }
`;

export const DragAndDropRealtimePlayer: React.FC<DragAndDropRealtimePlayerProps> = ({ pinSettings, children }) => {
  const currentView = useCurrentViewByType('DRAG_AND_DROP');
  const currentPin = useCurrentPin();

  const correctAnswers = useMemo(() => {
    const teacherSettings = currentPin?.teacherSettings as Record<string, unknown>;
    const correctAnswers = teacherSettings?.correctAnswers as Record<string, string[]> | undefined;

    return correctAnswers || {};
  }, [currentPin?.teacherSettings]);

  const {
    applyTransition,
    resetComponentsToOriginalPositions,
    componentsToAnimate,
    animateMultipleComponentsToPositions,
  } = useDragAndDropAnimation(correctAnswers);

  const pinComponents = useMemo(() => currentPin?.pinComponents || [], [currentPin?.pinComponents]);

  useEffect(() => {
    if (pinComponents && currentPin?.id) {
      // Animate components to their target positions
      if (currentView?.phase === 'results' && Object.keys(correctAnswers).length > 0) {
        const componentsToUpdate = componentsToAnimate.filter(
          (component: AnimatedComponent) =>
            !checkIsOverCorrectDropzone(component.componentId, pinComponents, correctAnswers)
        );

        animateMultipleComponentsToPositions(componentsToUpdate);
      } else if (currentView?.phase === 'input') {
        resetComponentsToOriginalPositions();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentView?.phase, currentPin?.id]);

  if (!currentView) {
    return null;
  }

  return (
    <DragAndDropPinComponent pinSettings={pinSettings} className={applyTransition ? transitionStyle : undefined}>
      {children}
    </DragAndDropPinComponent>
  );
};
